export interface KeyShoutFormValues {
	heading: string;
	content: string;
	buttonLink: string;
	webview: boolean;
	image: File | null;
}

export function formValuesToKeyShout(
	data: KeyShoutFormValues,
	id?: number
): Partial<KeyShout> {
	return {
		...(id !== undefined && { id }),
		heading: data.heading,
		content: data.content || null,
		buttonLink: data.buttonLink || null,
		webview: data.buttonLink ? data.webview : false,
		modalLink: null
	};
}
